import React from 'react'

import { GuikerMarkerIcon } from '@guiker/icons'

import { Marker, MarkerProps } from './Marker'

export const Guiker: React.FC<Omit<MarkerProps, 'icon'>> = ({ ...props }) => {
  return <Marker icon={<GuikerMarkerIcon />} {...props} />
}
